document.addEventListener('DOMContentLoaded', () => {
  const glossaryIndex = document.querySelector('.glossary-index');
  const glossaryLetters = document.querySelectorAll('.glossary-term-letter');

  function slideHorizontallyToHash(id) {
    const currentAnchor = document.querySelector(`[href="${id}"]`);
    glossaryIndex.querySelector('.glossary-index-letter.active').classList.remove('active');
    currentAnchor.classList.add('active');

    // Scroll horizontally to active element
    glossaryIndex.scrollTo({
      left: currentAnchor.offsetLeft - ((glossaryIndex.clientWidth - 30) / 2),
      behavior: 'smooth'
    });
  }

  if (window.location.hash) {
      const targetedAnchor = document.querySelector(`[href="${window.location.hash}"]`);
      if (targetedAnchor) {
        slideHorizontallyToHash(window.location.hash);
      }
  }

  let headerClass = '.section-header';
  if (window.matchMedia('(max-width: 990px)').matches) {
    headerClass = '.faq-sticky-header-mobile';
  }

  const header = document.querySelector('.section-header');

  let offset = header.offsetHeight * -1;
  if (window.matchMedia('(max-width: 990px)').matches) {
    document.documentElement.style.setProperty('--scroll-margin-top', `${glossaryIndex.offsetHeight + 20}px`);
    offset = (glossaryIndex.offsetHeight * -1);
  }

  const intersectionWindowSize = 100;
  const bottomRoot = (window.innerHeight - intersectionWindowSize + offset) * -1;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        slideHorizontallyToHash('#' + entry.target.id);
      }
    });
  }, {
    rootMargin: `${offset}px 0px ${bottomRoot}px 0px`,
    threshold: 0
  });

  Array.from(glossaryLetters).forEach(letter => observer.observe(letter));
});